<template>
  <div class="intell">
    <common-layout>
      <div slot="header">
        <h3>智能评价</h3>
      </div>
      <div slot="container">
        <div class="hot-search">
          <el-input
            placeholder="请输入成果名称"
            v-model="paramsObj.keyword"
            class="input-with-select"
            @keyup.enter.native="search"
            clearable
            @clear="search"
          >
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
          <!--<el-date-picker-->
          <!--  v-model="startTime"-->
          <!--  type="datetimerange"-->
          <!--  format="yyyy-MM-dd HH:mm:ss"-->
          <!--  value-format="yyyy-MM-dd HH:mm:ss"-->
          <!--  start-placeholder="开始日期"-->
          <!--  end-placeholder="请选择"-->
          <!--  @change="changeStartTime"-->
          <!--&gt;</el-date-picker>-->
          <!--<el-date-picker-->
          <!--  v-model="endTime"-->
          <!--  type="datetimerange"-->
          <!--  format="yyyy-MM-dd HH:mm:ss"-->
          <!--  value-format="yyyy-MM-dd HH:mm:ss"-->
          <!--  start-placeholder="完成日期"-->
          <!--  end-placeholder="请选择"-->
          <!--  style="margin-left: 20px;"-->
          <!--  @change="changeEndTime"-->
          <!--&gt;</el-date-picker>-->
          <!-- <el-select
            v-model="paramsObj.status"
            placeholder="请选择状态"
            style="margin-left:20px;"
            clearable
            @change="search"
          >
            <el-option label="审核中" :value="0"></el-option>
            <el-option label="已完成" :value="1"></el-option>
          </el-select> -->
        </div>

        <div class="hot-table">
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
            class="table"
          >
            <el-table-column type="index" width="50" label="序号" align="center">
              <template slot-scope="scope">
                <span>{{ scope.$index + (paramsObj.page - 1) * paramsObj.pageSize + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column label="申请人" prop="applicantName" align="center"></el-table-column>
            <el-table-column label="成果名称" prop="resultName" align="center"></el-table-column>
            <el-table-column label="原始材料" prop="originalMaterial" align="center">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.originalMaterial"
                  class="mini_btn"
                  size="mini"
                  type="text"
                  @click="look(scope.row.originalMaterial)"
                >
                  查看
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="查新报告" prop="newReport" align="center">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.newReport"
                  class="mini_btn"
                  size="mini"
                  type="text"
                  @click="look(scope.row.newReport)"
                >
                  查看
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="申请时间" prop="startTime" align="center"></el-table-column>
            <!-- <el-table-column label="完成时间" prop="endTime" align="center"></el-table-column> -->
            <!-- <el-table-column label="状态" prop="status" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.status == 0">审核中</span>
                <span v-if="scope.row.status == 1">已完成</span>
              </template>
            </el-table-column> -->
            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="text"
                  @click="handleDownLoad(scope.row)"
                >
                  下载报告
                </el-button>
                <!-- <el-button
                  v-else
                  class="mini_btn"
                  size="mini"
                  type="text"
                  @click="look(scope.row.fullReport)"
                >
                  查看报告
                </el-button>
                <el-upload
                  class="upload-demo"
                  :action="uploadURL"
                  name="file"
                  :show-file-list="false"
                  :on-success="response => handlePictureCardPreview(response, scope.row)"
                  accept=".pdf, .doc, .docx"
                >
                  <el-button size="mini" type="text">
                    {{ scope.row.status == 0 ? '上传报告' : '重新上传' }}
                  </el-button>
                </el-upload> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="paramsObj.page"
          :page-size="paramsObj.pageSize"
          layout="total, prev, pager, next"
          :total="total"
          style="text-align:left;margin:20px 0"
        ></el-pagination>
      </div>
    </common-layout>
    <el-dialog :visible.sync="iframeDialog" width="80%" center :append-to-body="true">
      <iframe width="100%" height="600px" :src="iframeSrc" frameborder="0"></iframe>
    </el-dialog>
  </div>
</template>

<script>
import CommonLayout from '../../components/common-layout.vue';
import { saveAs } from 'file-saver';
import JSZipUtils from 'jszip-utils';
import PizZip from 'pizzip';
import docxtemplater from 'docxtemplater';
import dateformat from '../../../utils/dateformat';
import { encode } from 'js-base64'
export default {
  components: {
    CommonLayout
  },
  data() {
    return {
      tableData: [],
      paramsObj: {
        keyword: '',
        pageSize: 10,
        page: 1,
        startTime: '',
        endStartTime: '',
        startEndTime: '',
        endTime: '',
        status: null
      },

      total: 10,
      startTime: [],
      endTime: [],
      iframeDialog: false,
      iframeSrc: ''
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.http
        .post(`${urlConfig.devUrl}apij2/admin-api/trade/application-record/page`, this.paramsObj)
        .then(res => {
          if (res.code == 0) {
            this.tableData = res.data.data;
            this.total = res.data.total;
            this.paramsObj.pageSize = res.data.per_page;
            this.paramsObj.page = res.data.current_page;
          }
        });
    },
    changeStartTime(val) {
      if (val) {
        this.paramsObj.startTime = val[0];
        this.paramsObj.endStartTime = val[1];
      } else {
        this.paramsObj.startTime = '';
        this.paramsObj.endStartTime = '';
      }
      this.getData();
    },
    changeEndTime(val) {
      if (val) {
        this.paramsObj.startEndTime = val[0];
        this.paramsObj.endTime = val[1];
      } else {
        this.paramsObj.startEndTime = '';
        this.paramsObj.endTime = '';
      }
      this.getData();
    },
    search() {
      this.getData();
    },
    //翻页
    handleCurrentChange(val) {
      this.getData();
    },
    look(url) {
      let three = url.substring(url.length - 3, url.length);
      if (three === 'pdf') {
        this.iframeSrc = url;
      } else {
        this.iframeSrc = `https://fileview.wayshine.top/onlinePreview?url=${encodeURIComponent(encode(url))}`;
      }
      this.iframeDialog = true;
    },
    handleDownLoad(val) {
      const _that = this;
      JSZipUtils.getBinaryContent('template.docx', function(error, content) {
        if (error) {
          throw error;
        }
        let zip = new PizZip(content);
        let doc = new docxtemplater();
        doc.loadZip(zip);
        var obj = _that.getReportTemplate(val.fullReport, val.startTime);
        doc.setData(obj);
        try {
          doc.render();
        } catch (error) {
          let e = {
            message: error.message,
            name: error.name,
            stack: error.stack,
            properties: error.properties
          };
          console.log(JSON.stringify({ error: e }));
          throw error;
        }
        let out = doc.getZip().generate({
          type: 'blob',
          mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        });
        saveAs(out, '科技成果标准化评价报告.docx');
      });
    },
    handlePictureCardPreview(file, item) {
      console.log('file', file, item);
      item.status = 1;
      item.fullReport = this.imgUrl + file.data.store_result;
      item.endTime = dateformat.format(new Date(), 'yyyy-MM-dd hh:mm:ss')
      this.http
        .post(`${urlConfig.devUrl}apij2/home-api/trade/application-record/update`, item)
        .then(res => {
          if (res.code == 0) {
            this.$message.success(`上传成功！`);
            this.getData();
          }
        });
    },
    getReportTemplate(val, time) {
      const list = val.split('\n');
      console.log('list', list);
      if (list.length <= 0) return;
      const first = list.findIndex(item => item.indexOf('第一部分：科技成果概述') > -1);
      const second = list.findIndex(item => item.indexOf('第二部分：技术成熟度评价') > -1);
      const third = list.findIndex(item => item.indexOf('第三部分：技术创新度评价') > -1);
      const fourth = list.findIndex(item => item.indexOf('第四部分：技术先进度评价') > -1);
      const fifth = list.findIndex(item => item.indexOf('第五部分：效益分析') > -1);
      const sixth = list.findIndex(item => item.indexOf('第六部分：团队评价') > -1);
      const namesixth = list.findIndex(item => item.indexOf('科技成果完成人员名单') > -1);

      const content = list.slice(11, first);
      const contentStr = content.join('');

      const firstList = list.slice(first + 1, second);
      const fisrtStr = firstList.join('');

      const secondList = list.slice(second + 1, third);
      const secondStr = secondList.join('');

      const thirdList = list.slice(third + 1, fourth);
      const thirdStr = thirdList.join('');

      const fourthList = list.slice(fourth + 1, fifth);

      const fifthList = list.slice(fifth + 1, sixth);
      var sixthList,sixthStr,tableData

      if(namesixth === -1){
        sixthList = list.slice(sixth + 1);
        sixthStr = sixthList.join('');
      }else{
        sixthList = list.slice(sixth + 1,namesixth);
        sixthStr = sixthList.join('');
        tableData = list.slice(namesixth + 1).map(el=>{
          var lis = el.split(' ');
          return {
            column1:lis[0],
            column2:lis[1],
            column3:lis[2],
            column4:lis[3],
            column5:lis[4],
            column6:lis[5],
            column7:lis[6],
            column8:lis[7]
          }
        })
      }
      console.log('contentStr', contentStr);
      const model = {
        a: list[1].slice(8, list[1].length),
        b: list[2].slice(7, list[2].length),
        c: list[3].slice(7, list[3].length),
        d: list[4].slice(8, list[4].length),
        achievementType: list[5].slice(5, list[5].length),
        contactName:list[6].slice(4, list[6].length),
        contactInformation:list[7].slice(5, list[7].length),
        startDate:list[8].slice(5, list[8].length),
        completionDate:list[9].slice(5, list[9].length),
        achievementProfiles:list[10].slice(5, list[10].length),
        tableData:tableData,
        e: contentStr,
        f: fisrtStr,
        g: secondStr,
        h: thirdStr,
        i_1: fourthList[0],
        i_2: fourthList[1],
        j_1: fifthList[1],
        j_2: fifthList[3],
        k: sixthStr,
        time: dateformat.format(new Date(time), 'yyyy年 MM月 dd日'),
        year: dateformat.yearToChineseCapital(new Date(time)) + '年'
      };
      return model;
    },
  }
};
</script>
<style lang="scss" scoped>
@include component(intell) {
  width: 100%;
  height: 100%;

  .hot-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    .el-input {
      width: 240px;
      margin: 0 15px;
    }
  }

  .hot-table {
    width: 100%;
    margin-top: 10px;
    border: 1px solid #eef1f6;
  }
  .upload-demo {
    margin-left: 10px;
    border: none;
    display: inline-block;
  }
}
</style>
